import moment from 'moment';

export function setAllowPrint(companyAssociation, override = false) {
  if (!companyAssociation) return false;
  let allowPrint;

  // check do not admit (disable print if true)
  allowPrint =
    companyAssociation.company &&
    !companyAssociation.person.doNotAdmit &&
    !companyAssociation.company.doNotAdmit &&
    companyAssociation.isActive &&
    companyAssociation.person.isActive &&
    companyAssociation.company.isActive;

  if (allowPrint && companyAssociation.qualificationStatus != null) {
    allowPrint = companyAssociation.qualificationStatus.isQualified;
  }

  if (override) {
    allowPrint = true;
  }

  return allowPrint;
}

export function willCallAllowPrint(willCall) {
  return willCall.exhibitor.qualificationStatus.isQualified;
}
export function checkValidMarket(market) {
  return moment().isBetween(
    market.registrationStartDate,
    market.registrationEndDate
  );
}

export function attendeeAllowPrint(attendee) {
  const {
    event: { eventDates },
  } = attendee;
  let allowPrint = false;
  // if there are event dates, check if today is between the start and end date
  if (eventDates && eventDates.length > 0) {
    const dates = eventDates.map((event) => new Date(event.date));
    const startDate = new Date(Math.min(...dates));
    const endDate = new Date(Math.max(...dates));
    const today = new Date().setHours(0, 0, 0, 0);
    if (today >= startDate && today <= endDate) {
      allowPrint = true;
    }
  }
  return allowPrint;
}
